import React, { Component } from "react";
import ReactDOM from "react-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import CarouselCard from "./CarouselCard";
import Product from "./Product";
import "../Assets/sass/style.scss";

export default function AuctionCarousel(props) {
  const products = props.data.filter((data) => data.AuctionEndTime);
  return (
    <div className="liveauction-secrion"   style={{maxWidth:'70vw' }}>
      <Carousel
        width="100%"
        interval={1000}
        centerMode={true}
        transitionTime={500}
        showArrows={true}
        centerSlidePercentage={14}
        infiniteLoop={true}
        selectedItem={2}

        infiniteLoop={true} 
        // selectedItem={4}
        showStatus={false}
        // autoPlay={true}
        showIndicators={false}
      >
        {products.map((product) => (
          <Product key={product._id} product={product} />
        ))}
      </Carousel>
    </div>
  );
}
